<template>
<div class="jira-modal">
    <modal v-show="modalState.jira_report"
           :container="'modal-container'"
           @close="updateModal('jira_report', false)">
        <template v-slot:header>
            <h3>Send Report to Jira</h3>
        </template>
        <template v-slot:body>
            <div class="section format-file-wrapper">
                <label class="label">Select file format to send</label>
                <multi-select :value="selectedReportTypes" :model="selectedReportTypes" :entries="reportTypes" :label="`Select report type`" @input="onConfigChanged(...arguments)"></multi-select>
            </div>
            <div class="section select-option-wrapper">
                <label class="label">Project</label>
                <select v-model="selectedProject" @change="toggleSelectedProject">
                    <option v-for="(project, key) in assignableJiraProject" :key="key" :value="project.key"><i>{{project.key}}</i> - {{ project.name }}</option>
                </select>
            </div>
            <div class="section select-option-wrapper" v-if="issueTypes.length || epicList.length">
                <label class="label">Project Detail</label>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="issueTypes.length">
                    <label class="label">Issue Type</label>
                    <select v-model="selectedIssueType">
                        <option v-for="(issueType, key) in issueTypes" :key="key" :value="issueType">{{ issueType.untranslatedName }}</option>
                    </select>
                </div>
                <div v-if="showFieldsForm">
                    <div class="epic-list-wrapper section select-option-wrapper"  v-for="(field, idx) in allowIssueTypeFields" :key="idx">
                        <label class="label"
                            :class="{'label-error': errors.includes(field.key)}"
                            v-if="field.key === 'parent'">{{field.name}} Key
                        </label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-else>{{field.name}}</label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-if="field.required">*</label>

                        <select v-model="fieldValues[field.key]" v-if="field.type == 'priority'">
                            <option v-for="(prio, key) in field.allowedValues" :key="key" :value="prio.name">{{ prio.name }}</option>
                        </select>
                        <textarea v-else-if="field.type == 'string'" v-model="fieldValues[field.key]"></textarea>
                        <div class="datepicker-container" v-else-if="field.type == 'date'">
                            <a-date-picker
                                :ref="field.key"
                                :format="dateFormat"
                                placeholder="Select Date"
                                :disabled-date="disabledDate"
                                @change="handleDateChange(field.key, ...arguments)"
                            />
                        </div>

                        <input v-else-if="field.type == 'array'" type="text" v-model="fieldValues[field.key]" placeholder="Separated by comma">
                        <input v-else-if="field.type == 'issuelink'" type="text" v-model="fieldValues[field.key]" placeholder="Input key">
                        <input v-else-if="field.type == 'number'" type="number" v-model="fieldValues[field.key]" placeholder="Input number">
                        <input v-else type="text" v-model="fieldValues[field.key]">
                        <label class="label-error" v-if="errors.includes(field.key)">
                            {{field.name}} is required
                        </label>
                    </div>
                </div>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="epicList.length">
                    <label class="label">Epic</label>
                    <select v-model="selectedEpicId">
                        <option v-for="(epic, key) in epicList" :key="key" :value="epic.id"><i>{{epic.key}}</i> - {{ epic.raw.fields.customfield_10011 }}</option>
                    </select>
                </div>
            </div>
            <div class="section select-option-wrapper">
                <label class="label">Assignee (Optional)</label>
                <select v-model="selectedAssignee">
                    <option v-if="!selectedAssignee" selected value="">Select assignee</option>
                    <option v-for="(user, key) in assignableJiraUser" :key="key" :value="user.account_id">{{ user.display_name }}</option>
                </select>
            </div>
        </template>
        <template v-slot:footer>
            <span v-if="isSubmitting">Sending report to Jira ...&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-pulse"></i></span>
            <button class="btn btn-primary" @click="sendReport()" v-else :class="{ 'btn-disabled': !canSubmit }">
                <i class="fa fa-paper-plane"></i>
                Send Report to Jira
            </button>
        </template>
    </modal>
    <modal v-show="modalState.jira_host_issues"
           :container="'modal-container'"
           @close="updateModal('jira_host_issues', false)">
        <template v-slot:header>
            <h3>Send Host to Jira</h3>
            <button type="button" class="close" aria-label="Close Modal" @click="updateModal('jira_host_issues', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p>Send host and its issues to Jira.</p>
            <div class="section select-option-wrapper">
                <label class="label">Project</label>
                <select v-model="selectedProject" @change="toggleSelectedProject">
                    <option v-for="(project, key) in assignableJiraProject" :key="key" :value="project.key"><i>{{project.key}}</i> - {{ project.name }}</option>
                </select>
            </div>
            <div class="section select-option-wrapper" v-if="issueTypes.length || epicList.length">
                <label class="label">Project Detail</label>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="issueTypes.length">
                    <label class="label">Issue Type</label>
                    <select v-model="selectedIssueType">
                        <option v-for="(issueType, key) in issueTypes" :key="key" :value="issueType">{{ issueType.untranslatedName }}</option>
                    </select>
                </div>
                <div v-if="showFieldsForm">
                    <div class="epic-list-wrapper section select-option-wrapper"  v-for="(field, idx) in allowIssueTypeFields" :key="idx">
                        <label class="label"
                            :class="{'label-error': errors.includes(field.key)}"
                            v-if="field.key === 'parent'">{{field.name}} Key
                        </label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-else>{{field.name}}</label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-if="field.required">*</label>

                        <select v-model="fieldValues[field.key]" v-if="field.type == 'priority'">
                            <option v-for="(prio, key) in field.allowedValues" :key="key" :value="prio.name">{{ prio.name }}</option>
                        </select>
                        <textarea v-else-if="field.type == 'string'" v-model="fieldValues[field.key]"></textarea>
                        <div class="datepicker-container" v-else-if="field.type == 'date'">
                            <a-date-picker
                                :ref="field.key"
                                :format="dateFormat"
                                placeholder="Select Date"
                                :disabled-date="disabledDate"
                                @change="handleDateChange(field.key, ...arguments)"
                            />
                        </div>

                        <input v-else-if="field.type == 'array'" type="text" v-model="fieldValues[field.key]" placeholder="Separated by comma">
                        <input v-else-if="field.type == 'issuelink'" type="text" v-model="fieldValues[field.key]" placeholder="Input key">
                        <input v-else-if="field.type == 'number'" type="number" v-model="fieldValues[field.key]" placeholder="Input number">
                        <input v-else type="text" v-model="fieldValues[field.key]">
                        <label class="label-error" v-if="errors.includes(field.key)">
                            {{field.name}} is required
                        </label>
                    </div>
                </div>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="epicList.length">
                    <label class="label">Epic</label>
                    <select v-model="selectedEpicId">
                        <option v-for="(epic, key) in epicList" :key="key" :value="epic.id"><i>{{epic.key}}</i> - {{ epic.raw.fields.customfield_10011 }}</option>
                    </select>
                </div>
            </div>
            <div class="section select-option-wrapper">
                <label class="label">Assignee (Optional)</label>
                <select v-model="selectedAssignee">
                    <option v-if="!selectedAssignee" selected value="">Select assignee</option>
                    <option v-for="(user, key) in assignableJiraUser" :key="key" :value="user.account_id">{{ user.display_name }}</option>
                </select>
            </div>
        </template>
        <template v-slot:footer>
            <span v-if="isSubmitting">Sending host and its issues to Jira ...&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-pulse"></i></span>
            <button class="btn btn-primary" @click="sendHost()" v-else :class="{ 'btn-disabled': !canSubmit }">
                <i class="fa fa-paper-plane"></i>
                Send Host to Jira
            </button>
        </template>
    </modal>
    <modal v-show="modalState.jira_issue_hosts"
           :container="'modal-container'"
           @close="updateModal('jira_issue_hosts', false)">
        <template v-slot:header>
            <h3>Send Issue to Jira</h3>
            <button type="button" class="close" aria-label="Close Modal" @click="updateModal('jira_issue_hosts', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p>Send issue and its affected hosts to Jira.</p>
            <div class="section select-option-wrapper">
                <label class="label">Project</label>
                <select v-model="selectedProject" @change="toggleSelectedProject">
                    <option v-for="(project, key) in assignableJiraProject" :key="key" :value="project.key"><i>{{project.key}}</i> - {{ project.name }}</option>
                </select>
            </div>
            <div class="section select-option-wrapper" v-if="issueTypes.length || epicList.length">
                <label class="label">Project Detail</label>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="issueTypes.length">
                    <label class="label">Issue Type</label>
                    <select v-model="selectedIssueType">
                        <option v-for="(issueType, key) in issueTypes" :key="key" :value="issueType">{{ issueType.untranslatedName }}</option>
                    </select>
                </div>
                <div v-if="showFieldsForm">
                    <div class="epic-list-wrapper section select-option-wrapper"  v-for="(field, idx) in allowIssueTypeFields" :key="idx">
                        <label class="label"
                            :class="{'label-error': errors.includes(field.key)}"
                            v-if="field.key === 'parent'">{{field.name}} Key
                        </label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-else>{{field.name}}</label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-if="field.required">*</label>

                        <select v-model="fieldValues[field.key]" v-if="field.type == 'priority'">
                            <option v-for="(prio, key) in field.allowedValues" :key="key" :value="prio.name">{{ prio.name }}</option>
                        </select>
                        <textarea v-else-if="field.type == 'string'" v-model="fieldValues[field.key]"></textarea>
                        <div class="datepicker-container" v-else-if="field.type == 'date'">
                            <a-date-picker
                                :ref="field.key"
                                :format="dateFormat"
                                placeholder="Select Date"
                                :disabled-date="disabledDate"
                                @change="handleDateChange(field.key, ...arguments)"
                            />
                        </div>

                        <input v-else-if="field.type == 'array'" type="text" v-model="fieldValues[field.key]" placeholder="Separated by comma">
                        <input v-else-if="field.type == 'issuelink'" type="text" v-model="fieldValues[field.key]" placeholder="Input key">
                        <input v-else-if="field.type == 'number'" type="number" v-model="fieldValues[field.key]" placeholder="Input number">
                        <input v-else type="text" v-model="fieldValues[field.key]">
                        <label class="label-error" v-if="errors.includes(field.key)">
                            {{field.name}} is required
                        </label>
                    </div>
                </div>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="epicList.length">
                    <label class="label">Epic</label>
                    <select v-model="selectedEpicId">
                        <option v-for="(epic, key) in epicList" :key="key" :value="epic.id"><i>{{epic.key}}</i> - {{ epic.raw.fields.customfield_10011 }}</option>
                    </select>
                </div>
            </div>
            <div class="section select-option-wrapper">
                <label class="label">Assignee (Optional)</label>
                <select v-model="selectedAssignee">
                    <option v-if="!selectedAssignee" selected value="">Select assignee</option>
                    <option v-for="(user, key) in assignableJiraUser" :key="key" :value="user.account_id">{{ user.display_name }}</option>
                </select>
            </div>
        </template>
        <template v-slot:footer>
            <span v-if="isSubmitting">Sending issue and its affected hosts to Jira ...&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-pulse"></i></span>
            <button class="btn btn-primary" @click="sendIssue()" v-else :class="{ 'btn-disabled': !canSubmit }">
                <i class="fa fa-paper-plane"></i>
                Send Issue to Jira
            </button>
        </template>
    </modal>
    <modal v-show="modalState.jira_cyber_fitness"
           :container="'modal-container'"
           @close="updateModal('jira_cyber_fitness', false)">
        <template v-slot:header>
            <h3>Send Cyber Fitness to Jira</h3>
        </template>
        <template v-slot:body>
            <div class="section select-option-wrapper">
                <label class="label">Project</label>
                <select v-model="selectedProject" @change="toggleSelectedProject">
                    <option v-for="(project, key) in assignableJiraProject" :key="key" :value="project.key"><i>{{project.key}}</i> - {{ project.name }}</option>
                </select>
            </div>
            <div class="section select-option-wrapper" v-if="issueTypes.length || epicList.length">
                <label class="label">Project Detail</label>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="issueTypes.length">
                    <label class="label">Issue Type</label>
                    <select v-model="selectedIssueType">
                        <option v-for="(issueType, key) in issueTypes" :key="key" :value="issueType">{{ issueType.untranslatedName }}</option>
                    </select>
                </div>
                <div v-if="showFieldsForm">
                    <div class="epic-list-wrapper section select-option-wrapper"  v-for="(field, idx) in allowIssueTypeFields" :key="idx">
                        <label class="label"
                            :class="{'label-error': errors.includes(field.key)}"
                            v-if="field.key === 'parent'">{{field.name}} Key
                        </label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-else>{{field.name}}</label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-if="field.required">*</label>

                        <select v-model="fieldValues[field.key]" v-if="field.type == 'priority'">
                            <option v-for="(prio, key) in field.allowedValues" :key="key" :value="prio.name">{{ prio.name }}</option>
                        </select>
                        <textarea v-else-if="field.type == 'string'" v-model="fieldValues[field.key]"></textarea>
                        <div class="datepicker-container" v-else-if="field.type == 'date'">
                            <a-date-picker
                                :ref="field.key"
                                :format="dateFormat"
                                placeholder="Select Date"
                                :disabled-date="disabledDate"
                                @change="handleDateChange(field.key, ...arguments)"
                            />
                        </div>

                        <input v-else-if="field.type == 'array'" type="text" v-model="fieldValues[field.key]" placeholder="Separated by comma">
                        <input v-else-if="field.type == 'issuelink'" type="text" v-model="fieldValues[field.key]" placeholder="Input key">
                        <input v-else-if="field.type == 'number'" type="number" v-model="fieldValues[field.key]" placeholder="Input number">
                        <input v-else type="text" v-model="fieldValues[field.key]">
                        <label class="label-error" v-if="errors.includes(field.key)">
                            {{field.name}} is required
                        </label>
                    </div>
                </div>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="epicList.length">
                    <label class="label">Epic</label>
                    <select v-model="selectedEpicId">
                        <option v-for="(epic, key) in epicList" :key="key" :value="epic.id"><i>{{epic.key}}</i> - {{ epic.raw.fields.customfield_10011 }}</option>
                    </select>
                </div>
            </div>
            <div class="section select-option-wrapper">
                <label class="label">Assignee (Optional)</label>
                <select v-model="selectedAssignee">
                    <option v-if="!selectedAssignee" selected value="">Select assignee</option>
                    <option v-for="(user, key) in assignableJiraUser" :key="key" :value="user.account_id">{{ user.display_name }}</option>
                </select>
            </div>
        </template>
        <template v-slot:footer>
            <span v-if="isSubmitting">Sending report to Jira ...&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-pulse"></i></span>
            <button class="btn btn-primary" @click="sendCyberFitnessToJira()" v-else>
                <i class="fa fa-paper-plane"></i>
                Send to Jira
            </button>
        </template>
    </modal>
    <modal v-show="modalState.jira_multiple_cyber_fitness"
           :container="'modal-container'"
           @close="updateModal('jira_multiple_cyber_fitness', false)">
        <template v-slot:header>
            <h3>Send Multiple Cyber Fitness to Jira</h3>
        </template>
        <template v-slot:body>
            <div class="section select-option-wrapper">
                <label class="label">Project</label>
                <select v-model="selectedProject" @change="toggleSelectedProject">
                    <option v-for="(project, key) in assignableJiraProject" :key="key" :value="project.key"><i>{{project.key}}</i> - {{ project.name }}</option>
                </select>
            </div>
            <div class="section select-option-wrapper" v-if="issueTypes.length || epicList.length">
                <label class="label">Project Detail</label>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="issueTypes.length">
                    <label class="label">Issue Type</label>
                    <select v-model="selectedIssueType">
                        <option v-for="(issueType, key) in issueTypes" :key="key" :value="issueType">{{ issueType.untranslatedName }}</option>
                    </select>
                </div>
                <div v-if="showFieldsForm">
                    <div class="epic-list-wrapper section select-option-wrapper"  v-for="(field, idx) in allowIssueTypeFields" :key="idx">
                        <label class="label"
                            :class="{'label-error': errors.includes(field.key)}"
                            v-if="field.key === 'parent'">{{field.name}} Key
                        </label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-else>{{field.name}}</label>
                        <label :class="{'label-error': errors.includes(field.key)}" class="label" v-if="field.required">*</label>

                        <select v-model="fieldValues[field.key]" v-if="field.type == 'priority'">
                            <option v-for="(prio, key) in field.allowedValues" :key="key" :value="prio.name">{{ prio.name }}</option>
                        </select>
                        <textarea v-else-if="field.type == 'string'" v-model="fieldValues[field.key]"></textarea>
                        <div class="datepicker-container" v-else-if="field.type == 'date'">
                            <a-date-picker
                                :ref="field.key"
                                :format="dateFormat"
                                placeholder="Select Date"
                                :disabled-date="disabledDate"
                                @change="handleDateChange(field.key, ...arguments)"
                            />
                        </div>

                        <input v-else-if="field.type == 'array'" type="text" v-model="fieldValues[field.key]" placeholder="Separated by comma">
                        <input v-else-if="field.type == 'issuelink'" type="text" v-model="fieldValues[field.key]" placeholder="Input key">
                        <input v-else-if="field.type == 'number'" type="number" v-model="fieldValues[field.key]" placeholder="Input number">
                        <input v-else type="text" v-model="fieldValues[field.key]">
                        <label class="label-error" v-if="errors.includes(field.key)">
                            {{field.name}} is required
                        </label>
                    </div>
                </div>
                <div class="epic-list-wrapper section select-option-wrapper" v-if="epicList.length">
                    <label class="label">Epic</label>
                    <select v-model="selectedEpicId">
                        <option v-for="(epic, key) in epicList" :key="key" :value="epic.id"><i>{{epic.key}}</i> - {{ epic.raw.fields.customfield_10011 }}</option>
                    </select>
                </div>
            </div>
            <div class="section select-option-wrapper">
                <label class="label">Assignee (Optional)</label>
                <select v-model="selectedAssignee">
                    <option v-if="!selectedAssignee" selected value="">Select assignee</option>
                    <option v-for="(user, key) in assignableJiraUser" :key="key" :value="user.account_id">{{ user.display_name }}</option>
                </select>
            </div>
        </template>
        <template v-slot:footer>
            <span v-if="isSubmitting">Sending report to Jira ...&nbsp;&nbsp;&nbsp;<i class="fa fa-spinner fa-pulse"></i></span>
            <button class="btn btn-primary" @click="sendMultipleCyberFitnessToJira()" v-else>
                <i class="fa fa-paper-plane"></i>
                Send to Jira
            </button>
        </template>
    </modal>
    <modal v-show="modalState.jira_return_success"
           :container="'modal-container'"
           @close="updateModal('jira_return_success', false)">
        <template v-slot:header>
            <h3>Successfully send to Jira</h3>
            <button type="button" class="close" aria-label="Close Modal" @click="updateModal('jira_return_success', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p>Jira ticket detail:</p>
            <div class="jira-issue-detail">
                <div class="section">
                    <div class="key">Issue ID</div>
                    <div class="value">{{successResponse.issue_id}}</div>
                </div>
                <div class="section">
                    <div class="key">Issue Key</div>
                    <div class="value">{{successResponse.issue_key}}</div>
                </div>
                <div class="section">
                    <div class="key">Issue Link</div>
                    <div class="value"><a :href="successResponse.issue_link" target="_blank">{{successResponse.issue_link}}</a></div>
                </div>
            </div>
        </template>
    </modal>
    <modal v-show="modalState.jira_return_fail"
           :container="'modal-container'"
           @close="updateModal('jira_return_fail', false)">
        <template v-slot:header>
            <h3>Oops, request failed.</h3>
            <button type="button" class="close" aria-label="Close Modal" @click="updateModal('jira_return_fail', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p>There is a problem with your request. We are currently not able to send the issue to Jira.</p>
        </template>
    </modal>
    <modal v-show="modalState.jira_return_success_multiple"
           :container="'modal-container'"
           @close="updateModal('jira_return_success_multiple', false)">
        <template v-slot:header>
            <h3 v-if="failResponseMultiple.length > 0 && successResponseMultiple.length === 0">Oops, request failed.</h3>
            <h3 v-else-if="failResponseMultiple.length > 0">Oops, not all issues are successfully sent.</h3>
            <h3 v-else>Successfully send to Jira</h3>
            <button type="button" class="close" aria-label="Close Modal" @click="updateModal('jira_return_success_multiple', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <div v-if="failResponseMultiple.length > 0 && successResponseMultiple.length === 0">
                <p>There is a problem with your request. We are currently not able to send the issue to Jira. </p>
            </div>
            <div v-else-if="successResponseMultiple.length > 0" class="jira-issue-detail">
                <p v-if="failResponseMultiple.length > 0">Here are the successful ticket detail:</p>
                <p v-else>Jira ticket detail:</p>
                <table class="multiple-responses">
                    <thead>
                        <tr>
                            <th>Issue ID</th>
                            <th>Issue Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in successResponseMultiple" :key="item.issue_id">
                            <td>{{item.issue_id}}</td>
                            <td><a :href="item.issue_link">{{item.issue_link}}</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="failResponseMultiple.length > 0" class="failed-list">
                <p>Unfortunately, there {{failResponseMultiple.length > 1 ? 'are' : 'is'}} {{failResponseMultiple.length}} more {{failResponseMultiple.length > 1 ? 'tickets' : 'ticket'}}  that {{failResponseMultiple.length > 1 ? 'are' : 'is'}} unsuccessful to send. </p>
            </div>
        </template>
    </modal>
</div>
</template>

<script>
// eslint-disable-next-line import/extensions
import '~/assets/js/global.js';
import moment from 'moment-timezone';
import MultiSelect from '~/components/shared/forms/multi-select.vue';
import Modal from '~/components/shared/templates/modal.vue';
import AntDatepicker from '~/components/__ui/datepicker/ant-datepicker.vue';

export default {
    name: 'modals-jira',
    components: {
        Modal,
        MultiSelect,
        // eslint-disable-next-line vue/no-unused-components
        'ant-datepicker': AntDatepicker,
    },
    props: {
        scan_id: String,
        host: String,
        issue: String,
        modalState: {
            jira_report: false,
            jira_host_issues: false,
            jira_issue_hosts: false,
            jira_return_success: false,
            jira_return_fail: false,
            jira_cyber_fitness: false,
            jira_multiple_cyber_fitness: false,
            jira_return_success_multiple: false,
        },
        shortnames: {
            type: Array,
        },

    },
    data() {
        return {
            isSubmitting: false,
            reportTypes: ['xlsx', 'json', 'csv'],
            selectedReportTypes: ['xlsx'],
            selectedAssignee: '',
            standardAssignee: '',
            selectedProject: '',
            standardProject: '',
            assignableJiraProject: [],
            jiraCredentials: null,
            allAssignees: {},
            allProjectDetails: {},
            issueTypes: [],
            epicList: [],
            selectedEpicId: '',
            selectedIssueType: {},
            fieldValues: {},
            requiredFields: [],
            extraFields: {},
            assignableJiraUser: [
                {
                    account_id: '6037c5594623c60069cca039',
                    display_name: 'Abdul Arfan',
                    email_address: 'arfan@srlabs.id',
                },
                {
                    account_id: '6045faa051471c006a9d9d56',
                    display_name: 'arjen',
                    email_address: '',
                },
                {
                    account_id: '6045faa30b7840006908ee12',
                    display_name: 'Eric Wong',
                    email_address: '',
                },
                {
                    account_id: '60812b40a6eda60068713cde',
                    display_name: 'gita',
                    email_address: '',
                },
                {
                    account_id: '6045faa151471c006a9d9d67',
                    display_name: 'Sandhiya Lazuardi',
                    email_address: '',
                },
            ],
            successResponse: {
                issue_id: '10159',
                issue_key: 'SS-147',
                issue_link: 'https://arfan.atlassian.net/browse/SS-147',
            },
            successResponseMultiple: [],
            failResponseMultiple: [],
            errors: [],
        };
    },
    methods: {
        disabledDate(current) {
            // Can not select days before today
            return current < moment().subtract(1, 'days');
        },
        handleDateChange(key, val) {
            const dateVal = val;
            this.fieldValues[key] = dateVal;
            const momentDateVal = moment(dateVal).format('yyyy-MM-DD');
            this.fieldValues[`${key}_value`] = momentDateVal;
            this.$forceUpdate();
        },
        toggleSelectedProject() {
            this.selectedEpicId = '';
            this.selectedIssueType = '';
            this.fieldValues = {};
            this.errors = [];
            this.requiredFields = [];
            this.extraFields = {};
            this.epicList = [];
            this.getAssigneeByProject(this.selectedProject);
            this.getProjectDetailByProject(this.selectedProject);
        },
        onConfigChanged(selectedReportTypes) {
            if (selectedReportTypes.length > 0) {
                this.selectedReportTypes = selectedReportTypes;
            } else {
                this.selectedReportTypes = ['xlsx'];
            }
        },
        resetConfig() {
            this.selectedReportTypes = ['xlsx'];
            this.setStandardAssignee();
            this.setStandardProject();
            this.selectedEpicId = '';
            this.selectedIssueType = '';
            this.fieldValues = {};
        },
        updateModal(type, state) {
            if (!this.isSubmitting) {
                if (state === false) {
                    this.resetConfig();
                }
                this.modalState[type] = state;
                this.$emit('updateModal', {
                    key: type,
                    state,
                });
            }
        },
        mappedJiraDetailValue() {
            // eslint-disable-next-line prefer-const
            let extraFields = {};
            // eslint-disable-next-line prefer-const
            let currentFieldValues = { ...this.fieldValues };
            this.allowIssueTypeFields.forEach((e) => {
                const { key } = e;
                const { type } = e;
                const value = currentFieldValues[key];
                if (value) {
                    if (e.key === 'parent') {
                        extraFields[key] = {};
                        extraFields[key].key = value;
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (type === 'array') {
                            const arrayValues = value.split(',');
                            extraFields[key] = arrayValues;
                        } else if (type === 'string') {
                            extraFields[key] = value;
                        } else if (type === 'issuelink') {
                            extraFields[key] = {};
                            extraFields[key].name = value;
                        } else if (type === 'date') {
                            const dateFormatValue = currentFieldValues[`${key}_value`];
                            extraFields[key] = dateFormatValue;
                            delete extraFields[`${key}_value`];
                            delete currentFieldValues[`${key}_value`];
                        } else {
                            extraFields[key] = value;
                        }
                    }
                    delete currentFieldValues[key];
                }
            });
            Object.keys(currentFieldValues).forEach((e) => {
                extraFields[e] = currentFieldValues[e];
            });
            // Check errors
            const keys = Object.keys(extraFields);
            const blankRequiredFields = this.requiredFields.filter((n) => !keys.includes(n));
            if (blankRequiredFields) {
                this.errors = blankRequiredFields;
            }
            this.extraFields = extraFields;
        },
        sendReport() {
            // eslint-disable-next-line prefer-const
            let self = this;
            this.isSubmitting = true;
            // eslint-disable-next-line prefer-const
            let payload = {
                assignee: self.selectedAssignee,
                project_key: self.selectedProject,
                report_types: self.selectedReportTypes,
            };
            this.mappedJiraDetailValue();
            payload.extra_fields = JSON.stringify(this.extraFields);
            if (this.selectedEpicId) {
                payload.epic_id = this.selectedEpicId;
            }
            if (this.errors.length) {
                this.isSubmitting = false;
            } else {
                this.doBackendRequest(
                    'POST',
                    `/api/jira/send_report?scan_id=${self.scan_id}`,
                    (responseJson) => {
                        self.isSubmitting = false;
                        self.successResponse = responseJson;
                        self.updateModal('jira_report', false);
                        self.updateModal('jira_return_success', true);
                    },
                    JSON.stringify(payload),
                    (response) => {
                        self.isSubmitting = false;
                        const type = 'error';
                        self.updateModal('jira_report', false);
                        self.$emit('updateModal', {
                            key: type,
                            state: true,
                            message: `There was a problem with your request: ${response[type]}`,
                        });
                    },
                );
            }
        },
        sendHost() {
            // eslint-disable-next-line prefer-const
            let self = this;
            this.isSubmitting = true;
            // eslint-disable-next-line vars-on-top
            // eslint-disable-next-line prefer-const
            let payload = {
                hostname: self.host,
                project_key: self.selectedProject,
                assignee: self.selectedAssignee,
            };
            this.mappedJiraDetailValue();
            payload.extra_fields = JSON.stringify(this.extraFields);
            if (this.selectedEpicId) {
                payload.epic_id = this.selectedEpicId;
            }
            if (this.errors.length) {
                this.isSubmitting = false;
            } else {
                this.doBackendRequest(
                    'POST',
                    `/api/jira/send_host?scan_id=${self.scan_id}`,
                    (responseJson) => {
                        self.isSubmitting = false;
                        self.successResponse = responseJson;
                        self.updateModal('jira_host_issues', false);
                        self.updateModal('jira_return_success', true);
                    },
                    JSON.stringify(payload),
                    (response) => {
                        self.isSubmitting = false;
                        // eslint-disable-next-line prefer-const
                        let type = 'error';
                        self.updateModal('jira_host_issues', false);
                        self.$emit('updateModal', {
                            key: type,
                            state: true,
                            message: `There was a problem with your request: ${response[type]}`,
                        });
                    },
                );
            }
        },
        sendIssue() {
            // eslint-disable-next-line no-var
            // eslint-disable-next-line prefer-const
            let self = this;
            this.isSubmitting = true;
            // eslint-disable-next-line prefer-const
            let payload = {
                shortnames: [self.issue],
                project_key: self.selectedProject,
                assignee: self.selectedAssignee,
            };
            this.mappedJiraDetailValue();
            payload.extra_fields = JSON.stringify(this.extraFields);
            if (this.selectedEpicId) {
                payload.epic_id = this.selectedEpicId;
            }
            if (this.errors.length) {
                this.isSubmitting = false;
            } else {
                this.doBackendRequest(
                    'POST',
                    `/api/jira/send_issue?scan_id=${self.scan_id}`,
                    (responseJson) => {
                        this.isSubmitting = false;
                        if (responseJson.all_successful) {
                            self.successResponse = JSON.parse(responseJson.issues[self.issue].data);
                            this.updateModal('jira_issue_hosts', false);
                            this.updateModal('jira_return_success', true);
                        } else {
                            this.updateModal('jira_return_fail', true);
                            this.updateModal('jira_issue_hosts', false);
                        }
                    },
                    JSON.stringify(payload),
                    () => {
                        self.isSubmitting = false;
                        self.updateModal('jira_issue_hosts', false);
                    },
                );
            }
        },
        sendCyberFitnessToJira() {
            this.isSubmitting = true;
            const payload = {
                shortnames: this.shortnames,
                project_key: this.selectedProject,
                assignee: this.selectedAssignee,
                assignee_display_name: this.getAssigneeDisplayName,
            };
            this.mappedJiraDetailValue();
            payload.extra_fields = JSON.stringify(this.extraFields);
            if (this.selectedEpicId) {
                payload.epic_id = this.selectedEpicId;
            }
            if (this.errors.length) {
                this.isSubmitting = false;
            } else {
                this.doBackendRequest(
                    'POST',
                    `/api/jira/send_cyber_fitness_exercises?scan_id=${this.scan_id}`,
                    (responseJson) => {
                        this.isSubmitting = false;

                        if (responseJson.jira_issues.success.length > 0) {
                            // eslint-disable-next-line prefer-destructuring
                            this.successResponse = responseJson.jira_issues.success[0];
                            this.$emit('jiraUpdateToCyberFitnessList', {
                                updatedTutorialNames: responseJson.jira_issues.success.map((issue) => issue.tutorial_name),
                                assignee: this.getAssigneeDisplayName,
                            });
                            this.updateModal('jira_return_success', true);
                        } else {
                            this.updateModal('jira_return_fail', true);
                        }

                        this.updateModal('jira_cyber_fitness', false);
                    },
                    JSON.stringify(payload),
                    () => {
                        this.isSubmitting = false;
                        this.updateModal('jira_return_fail', true);
                        this.updateModal('jira_cyber_fitness', false);
                    },
                );
            }
        },
        sendMultipleCyberFitnessToJira() {
            if (this.shortnames.length > 0 && this.selectedAssignee) {
                this.isSubmitting = true;
                const payload = {
                    shortnames: this.shortnames,
                    project_key: this.selectedProject,
                    assignee: this.selectedAssignee,
                    assignee_display_name: this.getAssigneeDisplayName,
                };
                this.mappedJiraDetailValue();
                payload.extra_fields = JSON.stringify(this.extraFields);
                if (this.selectedEpicId) {
                    payload.epic_id = this.selectedEpicId;
                }
                if (this.errors.length) {
                    this.isSubmitting = false;
                } else {
                    this.doBackendRequest(
                        'POST',
                        `/api/jira/send_cyber_fitness_exercises?scan_id=${this.scan_id}`,
                        (responseJson) => {
                            this.isSubmitting = false;
                            if (responseJson.jira_issues && responseJson.jira_issues.success.length > 0) {
                                // At least one ticket is successfully sent
                                this.successResponseMultiple = responseJson.jira_issues.success;
                                if (responseJson.jira_issues.fail.length > 0) {
                                    this.failResponseMultiple = responseJson.jira_issues.fail;
                                }

                                this.$emit('jiraUpdateToCyberFitnessList', {
                                    updatedTutorialNames: responseJson.jira_issues.success.map((issue) => issue.tutorial_name),
                                    assignee: this.getAssigneeDisplayName,
                                });

                                this.updateModal('jira_return_success_multiple', true);
                            } else {
                                // Not a single ticket is sent
                                this.updateModal('jira_return_fail', true);
                            }
                            this.updateModal('jira_multiple_cyber_fitness', false);
                        },
                        JSON.stringify(payload),
                        () => {
                            this.isSubmitting = false;
                            this.updateModal('jira_return_fail', true);
                            this.updateModal('jira_multiple_cyber_fitness', false);
                        },
                    );
                }
            }
        },
        setStandardAssignee() {
            this.selectedAssignee = this.standardAssignee;
        },
        setStandardProject() {
            this.selectedProject = this.standardProject;
        },
        getJiraCreds() {
            // eslint-disable-next-line prefer-const
            let self = this;
            this.doBackendRequest(
                'GET',
                '/api/jira/get_credentials',
                (response) => {
                    if (response) {
                        this.jiraCredentials = response;
                        if (response.standard_assignee.account_id) {
                            self.standardAssignee = response.standard_assignee.account_id;
                        }
                        self.standardProject = response.project_key;
                        self.$nextTick(() => {
                            self.getProjectList();
                        });
                    }
                },
                undefined,
                undefined,
            );
        },
        getProjectList() {
            // eslint-disable-next-line prefer-const
            let self = this;
            // eslint-disable-next-line prefer-const
            let payload = {
                server: this.jiraCredentials.server,
                user: this.jiraCredentials.user,
                user_credential: this.jiraCredentials.user_credential,
            };
            this.doBackendRequest(
                'POST',
                '/api/jira/project_list',
                (response) => {
                    if (response) {
                        if (response.projects) {
                            self.assignableJiraProject = response.projects;
                            self.setStandardProject();
                            self.getAssigneeByProject(self.standardProject);
                            self.getProjectDetailByProject(self.standardProject);
                        }
                    }
                },
                JSON.stringify(payload),
                () => {},
            );
        },
        getAssigneeByProject(projectKey = '') {
            let getAssignee = false;
            if (!projectKey) {
                // eslint-disable-next-line no-param-reassign
                projectKey = this.selected_project.key;
            }
            if (this.allAssignees[projectKey]) {
                this.assignableJiraUser = this.allAssignees[projectKey];
            } else {
                getAssignee = true;
            }

            if (getAssignee) {
                let payload = {};
                if (this.jiraCredentials) {
                    payload = this.jiraCredentials;
                } else {
                    payload = {
                        server: this.serverUrl,
                        user: this.email,
                    };
                    if (this.jiraSystem === 'cloud') {
                        payload.user_credential = this.apiToken;
                    } else {
                        payload.user_credential = this.password;
                    }
                }
                // eslint-disable-next-line prefer-const
                let self = this;
                this.doBackendRequest(
                    'POST',
                    `/api/jira/get_assignable_user_by_project?project_key=${projectKey}`,
                    (response) => {
                        self.allAssignees[projectKey] = response.assignee;
                        self.assignableJiraUser = response.assignee;
                        self.setStandardAssignee();
                    },
                    JSON.stringify(payload),
                    () => {},
                );
            }
        },
        getProjectDetailByProject(projectKey = '') {
            let getProjectDetail = false;
            if (!projectKey) {
                // eslint-disable-next-line no-param-reassign
                projectKey = this.selected_project.key;
            }
            if (this.allProjectDetails[projectKey]) {
                this.issueTypes = this.allProjectDetails[projectKey].issue_types;
                this.epicList = this.allProjectDetails[projectKey].epic_list;
            } else {
                getProjectDetail = true;
            }

            if (getProjectDetail) {
                const payload = {};
                // eslint-disable-next-line prefer-const
                let self = this;
                this.doBackendRequest(
                    'GET',
                    `/api/jira/project_detail_per_project?project_key=${projectKey}`,
                    (response) => {
                        if (!response.error) {
                            self.allProjectDetails[projectKey] = response;
                            this.issueTypes = response.issue_types;
                            this.epicList = response.epic_list;
                        }
                    },
                    JSON.stringify(payload),
                    () => {},
                );
            }
        },
    },
    computed: {
        canSubmit() {
            const keys = Object.keys(this.fieldValues);
            const blankRequiredFields = this.requiredFields.filter((n) => !keys.includes(n));
            return blankRequiredFields.length === 0;
        },
        dateFormat() {
            return 'DD-MMM-YYYY';
        },
        getAssigneeDisplayName() {
            if (this.selectedAssignee) {
                const found = this.assignableJiraUser.find((user) => user.account_id === this.selectedAssignee);
                return found.display_name;
            }
            return '';
        },
        allowIssueTypeFields() {
            const disableFields = ['attachment', 'assignee', 'project', 'issuetype', 'reporter', 'timetracking', 'components', 'issuelinks', 'fixVersions', 'summary'];
            // eslint-disable-next-line prefer-const
            let fields = [];
            if (Object.keys(this.selectedIssueType).length) {
                const issueTypeFields = Object.keys(this.selectedIssueType.fields);
                const selectedFields = issueTypeFields.filter((n) => !disableFields.includes(n));
                if (issueTypeFields.includes('project')) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.fieldValues.project = {
                        key: this.selectedProject,
                    };
                }
                if (issueTypeFields.includes('issuetype')) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.fieldValues.issuetype = {
                        id: this.selectedIssueType.id,
                    };
                }
                selectedFields.forEach((e) => {
                    const field = this.selectedIssueType.fields[e];
                    if (!(field.name === 'Epic Link')) {
                        // INSERT BASIC DATA
                        // eslint-disable-next-line prefer-const
                        let fieldData = {
                            key: field.key,
                            name: field.name,
                            required: field.required,
                            hasDefaultValue: field.hasDefaultValue,
                            type: field.schema.type,
                        };
                        if (field.allowedValues) {
                            fieldData.allowedValues = field.allowedValues;
                        }
                        if (field.hasDefaultValue) {
                            fieldData.defaultValue = field.defaultValue;
                        }

                        if (field.required) {
                            if (!this.requiredFields.includes(field.key)) {
                                this.requiredFields.push(field.key);
                            }
                        }
                        fields.push(fieldData);
                    }
                });
            }
            return fields;
        },
        showFieldsForm() {
            return (Object.keys(this.selectedIssueType).length > 0 && Object.keys(this.allowIssueTypeFields).length > 0);
        },
    },
    created() {
    },
    mounted() {
        this.getJiraCreds();
    },
    watch: {
        fieldValues: {
            handler(newVal) {
                this.fieldValues = newVal;
            },
            deep: true,
        },
    },
};
</script>


<style lang="scss">
.jira-modal {
    .label {
        margin: auto;
    }
    .multi-select {
        height: fit-content;
    }
    .section {
        margin: 1rem 0;
        .label {
            font-size: $font-size-label;
            color: $color-neutral-dark-200;
        }
        .label-error{
            font-size: $font-size-label;
            color: $danger !important;
        }
    }
    .select-option-wrapper {
        align-items: center;

        select, input, textarea {
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 2px;
            padding: 0 5px;
            width: 100%;
            background: white;
        }

        .datepicker-container {
            width: 100%;
        }
    }
    .jira-issue-detail {
        .section {
            display: flex;

            .key {
                flex: 1;
                font-weight: bold;
            }

            .value {
                flex: 2;
            }
        }

        .multiple-responses {
            border-collapse: separate;
            border-spacing: 0.5em;

            th:nth-child(1) {
                width: 25%;
            }
        }
    }
    .failed-list {
        padding: 1rem;
        margin-top: 2rem;
        background-color: $gray-100;
        p {
            margin-bottom: 0;
            color: $red;
        }
    }
    .modal-body {
        overflow: auto;
        max-height: 50vh;
    }
    .btn-disabled {
        cursor: not-allowed !important;
    }
}
</style>
